import { mergeAttributes, Node } from '@tiptap/core'

import { EmptyObject } from '~shared/core/primitives'
import { NodeAttributes } from '~shared/richtext/richtext.types'

export const VARIABLENODE_NAME = 'rsVariableNode' as const
export const VARIABLENODE_TAG = 'rs-variable' as const

/**
 * @deprecated We're migrating from `<variable data-type="variable" [...] />` to
 *   `<rs-variable [...] />`
 */
export const VARIABLENODE_TAG_LEGACY = 'variable' as const

type VariableNodeOptions = EmptyObject

export type VariableNodeAttributes = {
  variableKey: string
  fallbackValue: string
}

export const VariableNode = Node.create<VariableNodeOptions, VariableNodeAttributes>({
  name: VARIABLENODE_NAME,
  group: 'inline',
  atom: true,
  isolating: true,
  inline: true,
  selectable: false,
  defining: true,

  addAttributes() {
    return {
      variableKey: {
        parseHTML: (element) => element.getAttribute('data-variable-key'),
        renderHTML: (attributes) => {
          if (!attributes.variableKey) return {}

          return { 'data-variable-key': attributes.variableKey }
        },
      },
      // Fallback name to use after the mention was deleted
      fallbackValue: {
        parseHTML: (element) => element.getAttribute('data-fallback-value'),
        renderHTML: (attributes) => {
          if (!attributes.fallbackValue) return {}

          return { 'data-fallback-value': attributes.fallbackValue }
        },
      },
    } satisfies NodeAttributes<VariableNodeAttributes>
  },

  parseHTML() {
    return [
      { tag: VARIABLENODE_TAG },
      { tag: VARIABLENODE_TAG_LEGACY }, // Parse legacy tag during migration period
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      VARIABLENODE_TAG,
      mergeAttributes(HTMLAttributes),
      '', // Add empty child to force a closing tag
    ]
  },

  renderText({ node }) {
    // const attrs = node.attrs as VariableNodeAttributes
    // const variable = getVariableFromCache(attrs.variableKey)
    // const currentValue = variable?.value
    // const fallbackValue = attrs.fallbackValue ?? 'unknown'
    // return `$${currentValue ?? fallbackValue}`
    return node.text ?? '' // TODO: Implement safely
  },
})
